import { useEffect, useState } from 'react';
import { BasicContainer } from './BasicContainer';
import { Template } from '../Template';
import { useTreeStore } from '@/frontend/store/TreeStore';
import { RepeatingStep } from './RepeatingStep';
import { Step } from './Step';
import { ContainerButtonRow } from './ContainerButtonRow';
import { ContainerTreeObject } from '@/frontend/types/navigationTypes';
import { FunctionCall } from './FunctionCall';
import { CollapsibleAddRow } from '../buttons/CollapsibleAddRow';
import { I18n } from '@/i18n/I18n';

export function SectionItem(props: { initItem: ContainerTreeObject, parentShowCascade?: boolean }) {
  const { initItem, parentShowCascade } = props;
  const { container, children } = initItem;
  const { isScaffold } = container;


  const [showSection, setShowSection] = useState<boolean>(parentShowCascade === undefined ? true : parentShowCascade);
  const updateContainer = useTreeStore(state => state.updateContainer);

  useEffect(() => {
    setShowSection(parentShowCascade === undefined ? true : parentShowCascade);
  }, [parentShowCascade]);

  return (
    <div className="container-scroll card observed-element mt-2" id={`${initItem.id}`}>
      <div className="col card-body">
        <BasicContainer container={container} showSection={showSection} setShowSection={setShowSection} wbs={initItem.wbs} />
        {isScaffold &&
          <Template initItem={container} updateItem={(updatedContainer) => updateContainer({ container: updatedContainer })} />
        }
        <CollapsibleAddRow label={I18n.get('addContainerHere')} defaultOpen={children.length === 0}>
          <ContainerButtonRow parent={container} position={0} isScaffold={isScaffold} />
        </CollapsibleAddRow>
        <div>
            {children.map(child => {
              return (
                <div key={`container-${child.id}`}>
                  { child.container.isStep() && <Step initItem={child} parentShowCascade={showSection} /> }
                  { child.container.isRepeatingStep() && <RepeatingStep initItem={child} parentShowCascade={showSection} /> }
                  { child.container.isSection() && <SectionItem initItem={child} parentShowCascade={showSection} /> }
                  { child.container.isFunctionCall() && <FunctionCall initItem={child} /> }
                  { showSection &&
                    <CollapsibleAddRow label={I18n.get('addContainerHere')}>
                      <ContainerButtonRow parent={container} position={child.container.position + 1} isScaffold={isScaffold} />
                    </CollapsibleAddRow>
                  }
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
